(function(){

	// Library depencencies
	var Application = include('springroll.Application');
		Display = include('springroll.easeljs.EaselJSDisplay');

	var cm = include('cm');
	// Create a new application
	var app = new Application({
		name: "SpaceWasteOdyssey",
		canvasId: "stage",
		display: Display,
		configPath: 'assets/config/config.json',
		captionsPath: 'assets/config/captions.json',
		captions: 'captions',
		displayOptions:	{
			clearView: true,
		},
		maxWidth: 1664,
		maxHeight: 768

	});

	app.minWidth = 1024;
	app.maxWidth = 1664;
	app.maxHeight = 768;

	// Handle when app is ready to use
	app.on('init', function()
	{
		// Start application;
		this.game = new cm.Main();
		var s = this.display.stage.canvas;
		this.game.resize(s.width, s.height);

		if(this.container.connected !== true)
		{
			this.captions.mute = true;
			this.options.autoPause = true;
		}

	});

	app.on('resize', function(w, h) {
		if (this.game) {
			this.game.resize(w, h);
		}
	});

	app.on('update', function(delta) {

		if (this.game) {
			cm.tick = delta / 1000;
			this.game.update(delta);
		}
	});

	window.app = cm.app = app;

})();